export default __webpack_public_path__ + "static/media/profile-2.ba27f534.jpg";